export * from "./trend-report/trend-report.component";